import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, ArrowRight } from 'lucide-react';
export const ContactSection = () => {
  return <section id="contact" className="py-24 bg-navy-800 relative border-t border-navy-700" data-id="element-19">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <div className="bg-navy-900 border border-navy-700 rounded-sm overflow-hidden shadow-2xl" data-id="element-21">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-22">
            {/* Left side - Info */}
            <div className="p-10 md:p-16 bg-gradient-to-br from-navy-900 to-navy-800 relative overflow-hidden" data-id="element-23">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-ice-500 to-gold-500" data-id="element-24"></div>

              <motion.h2 initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="text-3xl md:text-4xl font-bold text-white mb-4 uppercase tracking-tight" data-id="element-25">
                Ready to Take the{' '}
                <span className="text-gold-500" data-id="element-26">Next Step?</span>
              </motion.h2>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="text-slate-300 mb-10 leading-relaxed" data-id="element-27">
                UHD wants to be known as the developmental and representation
                team that doesn't waste players' and families' time. We provide
                the tools you need to get to the next level.
              </motion.p>

              <div className="space-y-6" data-id="element-28">
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.2
              }} className="flex items-center gap-4 text-white" data-id="element-29">
                  <div className="w-12 h-12 bg-navy-800 flex items-center justify-center rounded-sm border border-navy-700" data-id="element-30">
                    <Mail className="text-ice-500 w-5 h-5" data-id="element-31" />
                  </div>
                  <div data-id="element-32">
                    <p className="text-sm text-slate-400 font-semibold uppercase tracking-wider" data-id="element-33">
                      Email Us
                    </p>
                    <p className="font-medium" data-id="element-34">
                      contact@universalhockeydev.com
                    </p>
                  </div>
                </motion.div>

                <motion.div initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.3
              }} className="flex items-center gap-4 text-white" data-id="element-35">
                  <div className="w-12 h-12 bg-navy-800 flex items-center justify-center rounded-sm border border-navy-700" data-id="element-36">
                    <Phone className="text-ice-500 w-5 h-5" data-id="element-37" />
                  </div>
                  <div data-id="element-38">
                    <p className="text-sm text-slate-400 font-semibold uppercase tracking-wider" data-id="element-39">
                      Call Us
                    </p>
                    <p className="font-medium" data-id="element-40">Available upon request</p>
                  </div>
                </motion.div>
              </div>
            </div>

            {/* Right side - Form */}
            <div className="p-10 md:p-16 bg-navy-800" data-id="element-41">
              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-42">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-43">
                  <div data-id="element-44">
                    <label htmlFor="firstName" className="block text-sm font-semibold text-slate-300 mb-2 uppercase tracking-wider" data-id="element-45">
                      First Name
                    </label>
                    <input type="text" id="firstName" className="w-full bg-navy-900 border border-navy-700 rounded-sm px-4 py-3 text-white focus:outline-none focus:border-ice-500 transition-colors" placeholder="John" data-id="element-46" />
                  </div>
                  <div data-id="element-47">
                    <label htmlFor="lastName" className="block text-sm font-semibold text-slate-300 mb-2 uppercase tracking-wider" data-id="element-48">
                      Last Name
                    </label>
                    <input type="text" id="lastName" className="w-full bg-navy-900 border border-navy-700 rounded-sm px-4 py-3 text-white focus:outline-none focus:border-ice-500 transition-colors" placeholder="Doe" data-id="element-49" />
                  </div>
                </div>

                <div data-id="element-50">
                  <label htmlFor="email" className="block text-sm font-semibold text-slate-300 mb-2 uppercase tracking-wider" data-id="element-51">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full bg-navy-900 border border-navy-700 rounded-sm px-4 py-3 text-white focus:outline-none focus:border-ice-500 transition-colors" placeholder="john@example.com" data-id="element-52" />
                </div>

                <div data-id="element-53">
                  <label htmlFor="level" className="block text-sm font-semibold text-slate-300 mb-2 uppercase tracking-wider" data-id="element-54">
                    Current Level of Play
                  </label>
                  <select id="level" className="w-full bg-navy-900 border border-navy-700 rounded-sm px-4 py-3 text-white focus:outline-none focus:border-ice-500 transition-colors appearance-none" data-id="element-55">
                    <option value="" data-id="element-56">Select Level</option>
                    <option value="youth" data-id="element-57">Youth (U10-U18)</option>
                    <option value="junior" data-id="element-58">Junior</option>
                    <option value="college" data-id="element-59">College (NCAA/ACHA)</option>
                    <option value="pro" data-id="element-60">Professional</option>
                  </select>
                </div>

                <div data-id="element-61">
                  <label htmlFor="message" className="block text-sm font-semibold text-slate-300 mb-2 uppercase tracking-wider" data-id="element-62">
                    Message
                  </label>
                  <textarea id="message" rows={4} className="w-full bg-navy-900 border border-navy-700 rounded-sm px-4 py-3 text-white focus:outline-none focus:border-ice-500 transition-colors resize-none" placeholder="How can we help you?" data-id="element-63"></textarea>
                </div>

                <button type="submit" className="w-full bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold text-lg py-4 rounded-sm transition-colors flex items-center justify-center gap-2" data-id="element-64">
                  Send Message
                  <ArrowRight className="w-5 h-5" data-id="element-65" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
};